// alterado - revisado

import {
    SvgIcon,
} from '@material-ui/core'

import { ReactComponent as clienteConjugeSvg } from './clienteConjuge.svg'

import { ReactComponent as familiaresSvg } from './familiares.svg'

import { ReactComponent as enderecosSvg } from './enderecos.svg'

import { ReactComponent as objetivosSvg } from './objetivos.svg'

import { ReactComponent as riscosSvg } from './riscos.svg'


export const SvgIconClienteConjuge = ( props ) => {
    return (
        <SvgIcon
            component={clienteConjugeSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconFamiliares = ( props ) => {
    return (
        <SvgIcon
            component={familiaresSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconEnderecos = ( props ) => {
    return (
        <SvgIcon
            component={enderecosSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconObjetivos = ( props ) => {
    return (
        <SvgIcon
            component={objetivosSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconRiscos = ( props ) => {
    return (
        <SvgIcon
            component={riscosSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}